import { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useDoctorsStore } from "../../../hooks";
import { FaUserDoctor } from "react-icons/fa6";
import { LoadingData, ErrorMessage } from "../../ui";

export const DoctorsCard = () => {
  // Datos del hook ----------------------------------------//
  const {
    //props
    isLoadingData,
    doctors,
    message,
    page,
    pageSize,

    //methods
    startGetDoctors,
  } = useDoctorsStore();
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (doctors.length === 0) {
      startGetDoctors(page, pageSize);
    }
  }, [doctors.length, startGetDoctors, page, pageSize]);

  return (
    <div className="card rounded border-0 shadow">
      <div className="p-4 border-bottom">
        <h5 className="mb-0">Lista de doctores</h5>
      </div>
      <SimpleBar style={{ height: "629px" }}>
        <ul className="list-unstyled mb-0 p-4">
          {isLoadingData && <LoadingData className="mb-3" />}
          {message?.type === "errorDoctors" && (
            <ErrorMessage className="mb-3">{message.text}</ErrorMessage>
          )}
          {doctors.map((doctor) => (
            <li
              className="d-md-flex align-items-center text-center text-md-start mb-3"
              key={doctor.id}
            >
              <FaUserDoctor className="flex-shrink-0 avatar avatar-medium rounded-md shadow bg-light text-secondary p-2" />
              <div className="ms-md-3 mt-4 mt-sm-0">
                <Link to="#" className="text-dark h6">
                  {doctor.firstName} {doctor.lastName}
                </Link>
                <p className="text-muted my-1">{doctor.specialtyName}</p>
              </div>
            </li>
          ))}
          <li>
            <Link to="/secretary/doctors" className="btn btn-soft-cyan">
              Todos los doctores
            </Link>
          </li>
        </ul>
      </SimpleBar>
    </div>
  );
};
